const hasValueClassName = 'form-item--has-value';
const translates = window.translates.datepicker;
$.datepicker.setDefaults($.datepicker.regional[translates.regional]);

const daysOfWeek = [
    $.datepicker._defaults.dayNamesMin[0],
    $.datepicker._defaults.dayNamesMin[1],
    $.datepicker._defaults.dayNamesMin[2],
    $.datepicker._defaults.dayNamesMin[3],
    $.datepicker._defaults.dayNamesMin[4],
    $.datepicker._defaults.dayNamesMin[5],
    $.datepicker._defaults.dayNamesMin[6]
];
const monthNames = [
    $.datepicker._defaults.monthNames[0],
    $.datepicker._defaults.monthNames[1],
    $.datepicker._defaults.monthNames[2],
    $.datepicker._defaults.monthNames[3],
    $.datepicker._defaults.monthNames[4],
    $.datepicker._defaults.monthNames[5],
    $.datepicker._defaults.monthNames[6],
    $.datepicker._defaults.monthNames[7],
    $.datepicker._defaults.monthNames[8],
    $.datepicker._defaults.monthNames[9],
    $.datepicker._defaults.monthNames[10],
    $.datepicker._defaults.monthNames[11]
];

function datepicker(elements) {
    $(elements).each((i, el) => {
        const $el = $(el);
        let parent = $el.data('datepicker-parent') ? $el.parents($el.data('datepicker-parent')) : $('body');
        const date = new Date();
        let today = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '.' + (date.getMonth() + 1 < 10 ? '0' + parseInt(date.getMonth() + 1) : date.getMonth() + 1) + '.' + date.getFullYear();
        let tomorrow = new Date(+new Date + 86400000);
        let firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        let oneYear = new Date();
        oneYear.setFullYear(oneYear.getFullYear() + 1);
        let twoWeeksAgo = new Date(+new Date - 12096e5);
        let monthAgo = new Date(+new Date - 2592000000);
        let minDate = $el.is('[data-from-today]') ? new Date() : '';
        let maxDate = $el.is('[data-to-today]') ? new Date() : '';
        let tomorrowFormatted = (tomorrow.getDate() < 10 ? '0' + tomorrow.getDate() : tomorrow.getDate()) + '.' + (tomorrow.getMonth() + 1 < 10 ? '0' + parseInt(tomorrow.getMonth() + 1) : tomorrow.getMonth() + 1) + '.' + tomorrow.getFullYear();
        let twoWeeksAgoFormatted = (twoWeeksAgo.getDate() < 10 ? '0' + twoWeeksAgo.getDate() : twoWeeksAgo.getDate())  + '.' + (twoWeeksAgo.getMonth() + 1 < 10 ? '0' + parseInt(twoWeeksAgo.getMonth() + 1) : twoWeeksAgo.getMonth() + 1) + '.' + twoWeeksAgo.getFullYear();
        let monthAgoFormatted = (monthAgo.getDate() < 10 ? '0' + monthAgo.getDate() : monthAgo.getDate()) + '.' + (monthAgo.getMonth() + 1 < 10 ? '0' + parseInt(monthAgo.getMonth() + 1) : monthAgo.getMonth() + 1) + '.' + monthAgo.getFullYear();
        if ($el.data('datepicker-type') === 'simple') {
            $el.daterangepicker({
                singleDatePicker: true,
                "timePickerSeconds": false,
                'parentEl': parent,
                "autoApply": true,
                'minDate': $el.is('[data-from-tomorrow]') ? tomorrow : $el.is('[data-from-first-of-month]') ? firstDayOfMonth : minDate,
                'startDate': $el.is('[data-from-tomorrow]') ? tomorrow : $el.is('[data-start-one-year]') ? oneYear : minDate,
                'endDate': $el.is('[data-from-tomorrow]') ? tomorrow : minDate,
                "locale": {
                    "format": "DD.MM.YYYY",
                    "weekLabel": "W",
                    "firstDay": 1,
                    'daysOfWeek': daysOfWeek,
                    'monthNames': monthNames
                },
                "autoUpdateInput": true,
                "opens": "left",
                "drops": "down"
            }, function (start, end, label) {
                    $el.val(start.format("DD.MM.YYYY"));
                   $(el).trigger('input change');
            });
        } else if ($el.data('datepicker-type') === 'simple-today') {
            $el.daterangepicker({
                    singleDatePicker: true,
                    showDropdowns: true,
                    showYearDropdown: true,
                    "timePickerSeconds": false,
                    'parentEl': parent,
                    "autoApply": true,
                    'maxDate': new Date(),
                    'endDate': new Date(),
                    'startDate': $el.val() ? $el.val() : '',
                    "locale": {
                        "format": "DD.MM.YYYY",
                        "firstDay": 1,
                        'daysOfWeek': daysOfWeek,
                        'monthNames': monthNames
                    },
                    "autoUpdateInput": true,
                    "opens": "left",
                    "drops": "down"
                }, function (start, end, label) {
                    $el.val(start.format('DD.MM.YYYY'));
                    $(el).trigger('input change');
                });
        } else {
            let config = {
                "timePickerSeconds": false,
                "autoApply": true,
                'parentEl': parent,
                "ranges": {
                    [translates.ranges.deleteFilter]: [ today , tomorrowFormatted],
                    [translates.ranges.todayLabel]: [today, today],
                    [translates.ranges.twoWeeksLabel]: [twoWeeksAgoFormatted, today],
                    [translates.ranges.thisMonthLabel]: [monthAgoFormatted, today]
                },
                'maxDate': maxDate,
                "locale": {
                    "format": "DD.MM.YYYY",
                    "separator": " - ",
                    "customRangeLabel": translates.ranges.customRangeLabel,
                    "weekLabel": "W",
                    "firstDay": 1,
                    'daysOfWeek': daysOfWeek,
                    'monthNames': monthNames
                },
                "alwaysShowCalendars": true,
                "autoUpdateInput": $el.data('datepicker-auto-update-input') || false,
                "opens": $el.data('datepicker-opens') || "left",
                "drops": "down"
            }
            if (!$el.data('datepicker-start-date')) {
                delete config.startDate;
            }
            if (!$el.data('datepicker-end-date')) {
                delete config.endDate;
            }

            if (!$el.data('to-today')) {
                delete config.maxDate;
            }

            if (!$el.data('from-today')) {
                delete config.minDate;
            }

            $el.daterangepicker(config, function (start, end, label) {
                var diapazon = "";
                if (label === translates.ranges.deleteFilter) {
                    $el.val(diapazon);
                }
                else {
                    diapazon = start.format('DD.MM.YYYY') + ' - ' + end.format('DD.MM.YYYY');
                    $el.val(diapazon);
                }
                $(el).trigger('input change');
            });
        }
        $el.on('apply.daterangepicker', () => {
            const value = $el.val();
            if (typeof value === 'string' && value.length) {
                $el.closest('.form-item').addClass(hasValueClassName);
            } else {
                $el.closest('.form-item').removeClass(hasValueClassName);
            }
            $(el).trigger('change');
        });
        
        if ($el.closest('[data-user-points]').length > 0) {
            window.loyaltyDatepicker = $el;
        }

        if ($el.is('[data-vchasno-date]')) {
            window.vchasnoDatepicker = $el;
        }
    });
}

export default function (elements) {
    datepicker(elements);
}